import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE, doMETHOD_UPDATE_TASK_ENABLE_STATUS} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_TASK_UPDATE = 'REQUEST_TASK_UPDATE'
export const doREQUEST_TASK_UPDATE = createDoRequestAction(REQUEST_TASK_UPDATE)

export const requestTaskUpdateActionCreators = {
  doREQUEST_TASK_UPDATE,
}

export function* requestTaskUpdate({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestTaskUpdate')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        taskId: v.string().uuid().exist(),
        color: v.string().length(6).optional(),
        index: v.number().optional(),
        enabled: v.boolean().optional(),
        scheduleRepeat: v.boolean().optional(),
        scheduleDescription: v.string().optional(),
        reminderList: v.array().optional(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_UPDATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {taskId, color, index, enabled, scheduleRepeat, scheduleDescription, reminderList} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/task-update`,
    accessToken,
    data: {
      taskId,
      color,
      index,
      enabled,
      scheduleRepeat,
      scheduleDescription,
      reminderList,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_UPDATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/task-update',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doMETHOD_UPDATE_TASK_ENABLE_STATUS({
      taskId: result.payload.id,
      enabled: result.payload.enabled,
    }),
  )

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_TASK_UPDATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* taskUpdateSaga() {
  yield takeEvery(REQUEST_TASK_UPDATE, requestTaskUpdate)
}
